var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#151A26"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.75 14.5C22.75 19.75 16 24.25 16 24.25C16 24.25 9.25 19.75 9.25 14.5C9.25 12.7098 9.96116 10.9929 11.227 9.72703C12.4929 8.46116 14.2098 7.75 16 7.75C17.7902 7.75 19.5071 8.46116 20.773 9.72703C22.0388 10.9929 22.75 12.7098 22.75 14.5Z",
    stroke: "#01FB34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16.75C17.2426 16.75 18.25 15.7426 18.25 14.5C18.25 13.2574 17.2426 12.25 16 12.25C14.7574 12.25 13.75 13.2574 13.75 14.5C13.75 15.7426 14.7574 16.75 16 16.75Z",
    stroke: "#01FB34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarker);
export default __webpack_public_path__ + "static/media/ic-marker.3ac49d43d4f218f14f26c216dbe143f3.svg";
export { ForwardRef as ReactComponent };